import gsap from 'gsap';
import Dispatch from '../core/Dispatch';
import {
    COMPONENT_INIT,
    MENU_CLOSED,
    MENU_CLOSING,
    MENU_OPENED,
    MENU_OPENING,
    UNLOAD
} from '../lib/events';
import Viewport from '../core/Viewport';
import Pattern from '../lib/Pattern';

export default el => {

    const burger = el.querySelector('button[aria-controls="menu"]');
    const menu = burger.nextElementSibling;
    const pageHeader = document.getElementById('top');

    let isOpen = false;
    let burgerTl;
    let menuTl;
    let patternInstance;

    if (!isOpen) {
        gsap.set(menu, { opacity: 0 });
    }

    const createBurgerTl = () => {
        if (burgerTl) {
            return;
        }
        const spans = Array.from(burger.children);
        burgerTl = gsap.timeline({
            paused: true,
            onReverseComplete() {
                burgerTl.kill();
                burgerTl = null;
            }
        })
            .to(spans[0], {
                y: 6,
                duration: 0.5,
                ease: 'Quad.easeIn'
            }, 'collapse')
            .to(spans[1], {
                y: -6,
                duration: 0.5,
                ease: 'Quad.easeIn'
            }, 'collapse')
            .to(spans[0], {
                rotate: 45,
                duration: 0.5,
                ease: 'Quad.easeOut'
            }, 'rotate')
            .to(spans[1], {
                rotate: -45,
                duration: 0.5,
                ease: 'Quad.easeOut'
            }, 'rotate');
    };

    const closeDisclosureMenu = (disclosureMenu, tween = true) => {
        menu.querySelectorAll(`button[aria-controls="${disclosureMenu.id}"]`).forEach(button => {
            button.setAttribute('aria-expanded', 'false');
        });
        disclosureMenu.inert = true;
        if (tween) {
            gsap.timeline({
                onComplete() {
                    disclosureMenu.hidden = true;
                }
            })
                .to(disclosureMenu, {
                    opacity: 0,
                    duration: 0.3
                }, 0)
                .to(disclosureMenu, {
                    x: -10,
                    duration: 0.3
                }, 0);
        } else {
            disclosureMenu.hidden = true;
        }
    };

    const openDisclosureMenu = (disclosureMenu, tween = true) => {
        disclosureMenu.hidden = false;
        disclosureMenu.inert = false;
        if (tween) {
            gsap.timeline()
                .fromTo(disclosureMenu, {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.3
                }, 0)
                .fromTo(disclosureMenu, {
                    x: -10
                }, {
                    x: 0,
                    duration: 0.3
                }, 0)
                .to(disclosureMenu.querySelectorAll('a'), {
                    opacity: 1,
                    duration: 0.3
                }, 0);
        } else {
            gsap.set(disclosureMenu, { clearProps: 'all' });
        }
        menu.querySelectorAll(`button[aria-controls="${disclosureMenu.id}"]`).forEach(button => {
            button.setAttribute('aria-expanded', 'true');
        });
        menu.querySelectorAll(`button[aria-expanded="true"]:not([aria-controls="${disclosureMenu.id}"])`).forEach(otherButton => {
            closeDisclosureMenu(document.getElementById(otherButton.getAttribute('aria-controls')), tween);
        });
        menu.querySelectorAll('[data-item]').forEach(linkOrButton => {
            gsap.to(linkOrButton, { opacity: linkOrButton.getAttribute('aria-controls') === disclosureMenu.id ? 1 : 0.6, duration: 0.3 });
        });
    };

    const open = (tween = true) => {
        if (isOpen) {
            return;
        }
        createBurgerTl();
        isOpen = true;
        burger.setAttribute('aria-expanded', 'true');
        document.body.classList.remove('menu-closing');
        document.body.classList.add('menu-opening');
        menu.hidden = false;
        Dispatch.emit(MENU_OPENING);
        gsap.to(burgerTl, {
            progress: 1,
            duration: 0.25,
            ease: 'none'
        });
        if (menuTl) {
            menuTl.kill();
        }
        //const menuItems = menu.querySelectorAll('[data-items]');
        //const menuOverlay = menu.querySelector('[data-overlay]');
        gsap.killTweensOf([menu]);//, menuItems, menuOverlay]);
        menuTl = gsap.timeline({
            paused: true,
            onComplete() {
                document.body.classList.remove('menu-opening');
                document.body.classList.add('menu-open');
                gsap.set([menu], { clearProps: 'all' });
                Dispatch.emit(MENU_OPENED);
            }
        })
            .to(menu, {
                opacity: 1,
                duration: 0.3
            }, 0);

        const menuItems = menu.querySelector('[data-items]');
        const promotedLinks = menu.querySelector('[data-promoted-links]');
        if (menuItems) {
            const { top: menuItemsTop } = menuItems.getBoundingClientRect();
            const { top: promotedLinksTop } = promotedLinks ? promotedLinks.getBoundingClientRect() : menuItems.getBoundingClientRect();
            const position = menuItemsTop < promotedLinksTop ? 0 : 0.15;
            menuTl
                .fromTo(menuItems, {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.3
                }, position)
                .fromTo(menuItems, {
                    y: 20
                }, {
                    y: 0,
                    duration: 0.5,
                    ease: 'Power2.easeOut'
                }, position);
        }

        if (promotedLinks) {
            const { top: menuItemsTop } = menuItems ? menuItems.getBoundingClientRect() : promotedLinks.getBoundingClientRect();
            const { top: promotedLinksTop } = promotedLinks.getBoundingClientRect();
            const position = menuItemsTop < promotedLinksTop ? 0.15 : 0;
            menuTl
                .fromTo(promotedLinks, {
                    opacity: 0
                }, {
                    opacity: 1,
                    duration: 0.3
                }, position)
                .fromTo(promotedLinks, {
                    y: 20
                }, {
                    y: 0,
                    duration: 0.5,
                    ease: 'Power2.easeOut'
                }, position);
        }

        // .fromTo(menuItems, { opacity: 0 }, {
        //     opacity: 1,
        //     duration: 0.3,
        //     ease: 'Cubic.easeIn'
        // }, 0)
        // .fromTo(menuItems, { y: 20 }, {
        //     y: 0,
        //     duration: 0.75,
        //     stagger: 0.15,
        //     ease: 'Quint.easeOut'
        // }, 0);
        // $(menu)
        //     .find('[data-item]')
        //     .on('mouseover', onItemMouseOver);
        // $(menu)
        //     .find('[data-item]')
        //     .on('mouseleave', onItemMouseLeave);

        if (tween) {
            menuTl.play();
        } else {
            menuTl.pause(menuTl.totalDuration(), false);
        }

        const pattern = el.querySelector('[data-pattern]');
        if (pattern) {
            patternInstance = Pattern(pattern);
        }

        try {
            Viewport.lockTabbing(pageHeader, burger);
        } catch (error) {
            console.error(error);
        }
    };

    const afterClose = () => {
        document.body.classList.remove('menu-closing');
        Dispatch.emit(MENU_CLOSED);
        menu.hidden = true;

        menu.querySelectorAll('button[aria-expanded="true"]').forEach(button => {
            closeDisclosureMenu(document.getElementById(button.getAttribute('aria-controls')), false);
        });

        gsap.set(menu.querySelectorAll('[data-item]'), { clearProps: 'all' });

        if (patternInstance) {
            patternInstance.destroy();
            patternInstance = null;
        }
    };

    const close = (tween = true) => {
        if (!isOpen) {
            return;
        }
        isOpen = false;
        burger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
        document.body.classList.remove('menu-opening');
        document.body.classList.add('menu-closing');
        Viewport.releaseTabbing(burger);
        Dispatch.emit(MENU_CLOSING);
        if (menuTl) {
            menuTl.kill();
            menuTl = null;
        }
        // const menuItems = menu.querySelectorAll('[data-items]');
        // const menuOverlay = menu.querySelector('[data-overlay]');
        gsap.killTweensOf([menu]);//, menuItems, menuOverlay]);
        if (tween) {
            gsap.to(burgerTl, {
                progress: 0,
                duration: 0.25,
                ease: 'none'
            });
            menuTl = gsap.timeline()
                .to(menu, {
                    opacity: 0,
                    duration: 0.29,
                    onComplete: afterClose
                }, 0);
        } else {
            gsap.set(burgerTl, { progress: 0 });
            afterClose();
        }
        // $(menu)
        //     .find('[data-item]')
        //     .off('mouseover mouseleave');
    };

    const toggle = () => {
        if (isOpen) {
            close();
        } else {
            open();
        }
    };

    const onBodyKeyUp = e => {
        if (!isOpen) {
            return;
        }
        const key = e.key || e.keyCode || e.which || null;
        if (key === 'Escape' || key === 27) {
            close();
        }
    };

    const onDisclosureMenuButtonClick = e => {
        const disclosureMenu = document.getElementById(e.currentTarget.getAttribute('aria-controls'));
        if (e.currentTarget.getAttribute('aria-expanded') === 'true') {
            closeDisclosureMenu(disclosureMenu);
        } else {
            openDisclosureMenu(disclosureMenu);
        }
    };

    const onPageUnload = () => {
        if (!isOpen) {
            return;
        }
        close();
    };

    const onLinkOrButtonMouseEnter = e => {
        const expandedItems = [...menu.querySelectorAll('button[data-item][aria-expanded="true"]')];
        menu.querySelectorAll('[data-item]').forEach(linkOrButton => {
            gsap.to(linkOrButton, { opacity: linkOrButton === e.currentTarget ? 1 : 0.6, duration: 0.3 });
            if (expandedItems.indexOf(linkOrButton) > -1) {
                const disclosureMenu = document.getElementById(linkOrButton.getAttribute('aria-controls'));
                gsap.to(disclosureMenu.querySelectorAll('a'), { opacity: linkOrButton === e.currentTarget ? 1 : 0.6, duration: 0.3 });
            }
        });
    };

    const onLinkOrButtonMouseLeave = e => {
        const expandedItems = [...menu.querySelectorAll('button[data-item][aria-expanded="true"]')];
        if (expandedItems.length) {
            menu.querySelectorAll('[data-item]').forEach(linkOrButton => {
                gsap.to(linkOrButton, { opacity: expandedItems.indexOf(linkOrButton) > -1 ? 1 : 0.6, duration: 0.3 });
                if (expandedItems.indexOf(linkOrButton) > -1) {
                    const disclosureMenu = document.getElementById(linkOrButton.getAttribute('aria-controls'));
                    gsap.to(disclosureMenu.querySelectorAll('a'), { opacity: 1, duration: 0.3 });
                }
            });
        } else {
            gsap.to(menu.querySelectorAll('[data-item]'), { opacity: 1, duration: 0.3 });
        }
    };

    const init = () => {
        burger.addEventListener('click', toggle);
        menu.querySelectorAll('button[aria-expanded]').forEach(button => {
            button.addEventListener('click', onDisclosureMenuButtonClick);
        });
        menu.querySelectorAll('[data-item]').forEach(linkOrButton => {
            linkOrButton.addEventListener('mouseenter', onLinkOrButtonMouseEnter);
            linkOrButton.addEventListener('mouseleave', onLinkOrButtonMouseLeave);
        });
        document.body.addEventListener('keyup', onBodyKeyUp);
        Dispatch.on(UNLOAD, onPageUnload);

        if (!menu.hidden) {
            open(false);
        }
    };

    const destroy = () => {
        burger.removeEventListener('click', toggle);
        menu.querySelectorAll('button[aria-expanded]').forEach(button => {
            button.removeEventListener('click', onDisclosureMenuButtonClick);
        });
        menu.querySelectorAll('[data-item]').forEach(linkOrButton => {
            linkOrButton.removeEventListener('mouseenter', onLinkOrButtonMouseEnter);
            linkOrButton.removeEventListener('mouseleave', onLinkOrButtonMouseLeave);
        });
        document.body.removeEventListener('keyup', onBodyKeyUp);
        if (patternInstance) {
            patternInstance.destroy();
            patternInstance = null;
        }
        Dispatch.off(UNLOAD, onPageUnload);
        if (isOpen) {
            close(false);
        }
    };

    Dispatch.emit(COMPONENT_INIT);

    return {
        init,
        destroy
    };

};
